import type { Form as FormType } from '~/types';
import { h, defineComponent, useAttrs, type PropType } from 'vue';
import UiForm from '@nuxt/ui/components/Form.vue';
import UiFormField from '@nuxt/ui/components/FormField.vue';
import UiInput from '@nuxt/ui/components/Input.vue';
import UiTextarea from '@nuxt/ui/components/Textarea.vue';
import UiCheckbox from '@nuxt/ui/components/Checkbox.vue';
import UiButton from '@nuxt/ui/components/Button.vue';
import VUpload from '~/components/base/VUpload.vue';
import VSignature from '~/components/base/VSignature.vue';

const UiInputComponent = UiInput as any;
const UiTextareaComponent = UiTextarea as any;

const widthClassMap = {
  '33': 'md:col-span-2',
  '50': 'md:col-span-3',
  '67': 'md:col-span-4',
  '100': 'md:col-span-6',
};

export default defineComponent({
  props: {
    schema: {
      type: Array as PropType<FormType['schema']>,
      default: () => [],
    },
    state: {
      type: Object,
      default: () => ({}),
    },
    validate: {
      type: Function,
    },
    onSubmit: {
      type: Function,
    },
    submitLabel: {
      type: String,
      default: 'Submit',
    },
  },
  setup(props) {
    const attrs = useAttrs();

    function getValidationRules(item: { [key: string]: any }) {
      if (typeof item.validation !== 'string') {
        return [];
      }

      return item.validation.split('|').map((rule: string) => rule.trim()).filter(Boolean);
    }

    function renderInput(item: { [key: string]: any }, name: string, state: any) {
      const commonProps = {
        name,
        class: 'w-full',
        modelValue: state[name],
        'onUpdate:modelValue': (value: any) => (state[name] = value),
      };
      switch (item.type) {
        case 'textarea':
          return h(UiTextareaComponent, { ...commonProps, placeholder: item.placeholder, ui: { root: 'w-full' } });
        case 'file':
          return h(VUpload, { ...commonProps, placeholder: item.placeholder });
        case 'signature':
          return h(VSignature, { ...commonProps, placeholder: item.placeholder });
        case 'checkbox':
          return h(UiCheckbox, commonProps);
        default:
          return h(UiInputComponent, { ...commonProps, placeholder: item.placeholder, type: item.type, ui: { root: 'w-full' } });
      }
    }
    const groups = (props.schema ?? []).map((item) => {
      const { name, label, description, help } = item as { [key: string]: any };
      const validationRules = getValidationRules(item as { [key: string]: any });

      // @ts-ignore
      const cssClass = widthClassMap[item.width] || 'md:col-span-6';

      return h(
        UiFormField,
        {
          name,
          label,
          description,
          help,
          required: validationRules.includes('required'),
          class: cssClass,
          size: 'lg',
        },
        () => [
          // @ts-ignore
          renderInput(item, name, props.state),
        ],
      );
    });

    if (!groups) {
      return;
    }

    // Add the submit button to the groups array
    groups.push(
      h('div', { class: 'md:col-span-6' }, [
        h(UiButton, {
          type: 'submit',
          size: 'lg',
          label: props.submitLabel,
          class:
            'px-8 text-white dark:text-white hover:shadow-totem-pole-500 hover:dark:shadow-submarine-800 hover:shadow-lg',
        }),
        h('div', { id: 'test' }),
      ]),
    );

    // @ts-ignore
    return () => h(UiForm, { ...attrs, state: props.state, validate: props.validate, onSubmit: props.onSubmit }, () => groups);
  },
});
